import { render } from "./ReviewEdit.vue?vue&type=template&id=148e61c6&scoped=true"
import script from "./ReviewEdit.vue?vue&type=script&lang=js"
export * from "./ReviewEdit.vue?vue&type=script&lang=js"

import "./ReviewEdit.vue?vue&type=style&index=0&id=148e61c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148e61c6"]])

export default __exports__